__turbopack_context__.v({
  "card": "OfferCard-module__1mFyeq__card",
  "header": "OfferCard-module__1mFyeq__header",
  "menu": "OfferCard-module__1mFyeq__menu",
  "name": "OfferCard-module__1mFyeq__name",
  "nameEdit": "OfferCard-module__1mFyeq__nameEdit",
  "nameInput": "OfferCard-module__1mFyeq__nameInput",
});
